<template>
        <div class="card mb-3 box-shadow">
            <div class="card-header">
                <h4 class="my-0 font-weight-normal">{{label}}</h4>
                <!--
                <a :href="more_info.link">{{more_info.text}}</a>
                -->
            </div>
            <div class="card-body">
                <h1 class="card-title pricing-card-title">
                            <span :style="strikethrough_style">
                                <span style="color:black;">
                                    ${{pricing_details.regular}}
                                </span>
                            </span>
                    <small class="text-muted">/ {{duration_short}}</small>
                </h1>
                <ul class="list-unstyled mt-3 mb-4">
                    <li v-for="limit in limits">{{limit}}</li>
                </ul>
                <div v-if="pricing_details.discounted" style="margin-bottom: 15px; color:black;background-color: #FFC857;padding:20px;">
                    <div style="font-family: adelle, serif;">
                        <strong>${{pricing_details.discounted}} / {{duration_short}}</strong>
                    </div>
                    <div style="font-family: freight-sans-pro, sans-serif;">
                        {{pricing_details.discounted_text}}
                    </div>
                </div>
                <el-button type="primary" @click="start()">Buy now</el-button>

            </div>
        </div>
</template>

<script>
    export default {
        name: "PricingCard",
        props: ['pricing_details','label','duration_short','limits','more_info'],
        computed: {
            strikethrough_style: function() {
                if (this.pricing_details.discounted_text) {
                    return "color:#D64933;text-decoration:line-through"
                } else {
                    return ""
                }
            }
        },
        methods: {
            start() {
                console.log('in start in PricingCard.vue')
                this.$emit('start')
            }
        }
    }
</script>

<style scoped>

</style>